<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span class="firm-clickable" @click="handelReturn">人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="firm-clickable" @click="handelReturn">文件库管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>

    <div class="box">
      <div class="information">
        <div class="left">
          <div class="left-img">
            <img src="@/assets/imgs/tx1@3x.svg" alt="" />
          </div>
          <div class="left-text">
            <div>
              <span style="font-size: 16px; color: #333; font-weight: 600">{{
                Information.name
              }}</span>
              <span>{{ Information.sex == 0 ? "女" : "男" }}</span>
              <span>{{ Information.idNumber }}</span>
              <span>出生日期：{{ Information.birthday }}</span>
            </div>
            <div
              style="margin-top: 20px; justify-content: start"
              class="flex-box"
            >
              <div class="flex-box" style="justify-content: start">
                <img src="@/assets/imgs/dianhua-weijiaohuan@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ Information.phone }}</span>
              </div>
              <div class="flex-box" style="justify-content: start">
                <img src="@/assets/imgs/youxiang@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ Information.mail }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div>
            <span>所在部门：{{ Information.department }}</span>
            <span style="margin-left: 40px"
              >所在职位：{{ Information.positionName }}</span
            >
          </div>
          <div style="margin-top: 20px">
            <span
              >在职时间：{{ Information.jobStartTime }} ——
              {{
                Information.leaveTime != null ? Information.leaveTime : "至今"
              }}</span
            >
            <!-- <span style="margin-left: 20px" v-if="Information.onJobYear>0"
              >共 {{ Information.onJobYear }} 年</span
            >
            <span style="margin-left: 20px" v-else-if="Information.onJobYear==null"
              >共 -- 年</span
            >
            <span style="margin-left: 20px" v-else>不满1年</span> -->
          </div>
        </div>
      </div>
      <div class="flex-box" style="margin-top: 30px">
        <div
          class="box-item"
          :class="{
            'box-item--no-file': !hasContractFiles,
          }"
          @click="handelImgDetails(1)"
        >
          <div class="top-right">
            <div
              v-if="
                Attachment.creditAuditStatus == 0 ||
                Attachment.creditAuditStatus == 2 ||
                Attachment.creditAuditStatus == 3 ||
                Attachment.creditAuditStatus == 5 ||
                Attachment.creditAuditStatus == null
              "
              class="button-box firm-clickable"
              style="color: #409eff "
              @click.stop="onVisible"
            >
              编辑
            </div>
            <div
              v-if="
                Attachment.creditAuditStatus == 0 ||
                Attachment.creditAuditStatus == 2 ||
                Attachment.creditAuditStatus == 3 ||
                Attachment.creditAuditStatus == 5 ||
                Attachment.creditAuditStatus == null
              "
              class="button-box firm-clickable"
              style="color: #fe574a"
              @click.stop="handelClear(1)"
            >
              清空
            </div>
          </div>
          <div
            style="
              margin-top: 40%;
              font-size: 28px;
              color: #333333;
              text-align: center;
              font-weight: 400;
            "
          >
            劳动合同
          </div>
          <div
            style="
              margin-top: 30px;
              font-size: 12px;
              color: #666;
              text-align: center;
            "
          >
            {{ Information.department || "--" }}
          </div>
          <div
            style="
              margin-top: 50px;
              font-size: 16px;
              color: #666;
              text-align: center;
            "
          >
            {{ companyName }}
          </div>
          <div
            style="
              float: right;
              margin-top: 100px;
              font-size: 18px;
              color: #666;
            "
          >
            共{{ contractFileCount }}页
          </div>
        </div>
        <div
          class="box-item"
          :class="{ 'box-item--no-file': !hasResumeFiles }"
          @click="handelImgDetails(2)"
        >
          <div class="top-right">
            <div
              v-if="
                Attachment.creditAuditStatus == 0 ||
                Attachment.creditAuditStatus == 2 ||
                Attachment.creditAuditStatus == 3 ||
                Attachment.creditAuditStatus == 5 ||
                Attachment.creditAuditStatus == null
              "
              class="button-box firm-clickable"
              style="color: #409eff "
              @click.stop="onVisibleResume"
            >
              编辑
            </div>
            <div
              v-if="
                Attachment.creditAuditStatus == 0 ||
                Attachment.creditAuditStatus == 2 ||
                Attachment.creditAuditStatus == 3 ||
                Attachment.creditAuditStatus == 5 ||
                Attachment.creditAuditStatus == null
              "
              class="button-box firm-clickable"
              style="color: #fe574a"
              @click.stop="handelClear(2)"
            >
              清空
            </div>
          </div>
          <div
            style="
              margin-top: 40%;
              font-size: 28px;
              color: #333333;
              text-align: center;
              font-weight: 400;
            "
          >
            简历
          </div>
          <div
            style="
              margin-top: 30px;
              font-size: 12px;
              color: #666;
              text-align: center;
            "
          >
            {{ Information.department || "--" }}
          </div>
          <div
            style="
              margin-top: 50px;
              font-size: 16px;
              color: #666;
              text-align: center;
            "
          >
            {{ companyName }}
          </div>
          <div
            style="
              float: right;
              margin-top: 100px;
              font-size: 18px;
              color: #666;
            "
          >
            共{{ resumeFileCount }}页
          </div>
        </div>

        <div class="box-item" v-if="leaveOrNot != 0">
          <div class="top-right">
            <div
              class="button-box firm-clickable"
              style="color: #409eff "
              @click="goEdit(Attachment.creditAuditStatus)"
            >
              {{
                Attachment.creditAuditStatus == 1
                  ? "审核中"
                  : Attachment.creditAuditStatus == 2
                  ? "重新评价"
                  : Attachment.creditAuditStatus == 3
                  ? "追加评价"
                  : Attachment.creditAuditStatus == 4
                  ? "取消审核"
                  : Attachment.creditAuditStatus == 5
                  ? "追加失败"
                  : Attachment.creditAuditStatus == 7
                  ? "重新追加"
                  : Attachment.creditAuditStatus == 6
                  ? "查看"
                  : Attachment.creditAuditStatus == 0
                  ? "评价"
                  : "评价"
              }}
            </div>
          </div>
          <div
            style="
              margin-top: 40%;
              font-size: 28px;
              color: #333333;
              text-align: center;
              font-weight: 400;
            "
          >
            信用评价
          </div>
          <div
            style="
              margin-top: 30px;
              font-size: 12px;
              color: #666;
              text-align: center;
            "
          >
            {{ Information.department || "--" }}
          </div>
          <div
            style="
              margin-top: 50px;
              font-size: 16px;
              color: #666;
              text-align: center;
            "
          >
            {{ companyName }}
          </div>
          <div
            class="Rejection"
            v-if="
              Attachment.creditAuditStatus == 2 ||
              Attachment.creditAuditStatus == 5
            "
            style="cursor: pointer"
            @click="dialogReason = true"
          >
            <span>驳回原因</span>
            <!-- {{ Attachment.reason || "--" }} -->
          </div>
          <div
            style="
              float: right;
              margin-top: 100px;
              font-size: 18px;
              color: #666;
            "
          >
            <!-- {{
              Information.applyForEvaluate != null &&
              Information.applyForEvaluate != []
                ? Information.applyForEvaluate[0].createTime
                : "--"
            }} -->
          </div>
        </div>
      </div>

      <ImgDetails
        :dialogIMGDetails="dialogIMGDetails"
        :IMGdata="IMGdata"
        @handleCancel="handleCancel"
      ></ImgDetails>
      <ImgUpload
        :dialogUpload="dialogUpload"
        @handleCloseUpload="handleCloseUpload"
        @handleUpload="handleUpload"
        :Title="Title"
        :Attachment="Attachment"
      ></ImgUpload>
      <!-- 驳回原因 -->
      <ReasonWin
        :dialogReason="dialogReason"
        :Instruction="Attachment.reason"
        :title="'驳回原因'"
        @handleCloseReason="dialogReason = false"
      ></ReasonWin>
    </div>
  </div>
</template>

<script>
import ImgDetails from "./components/ImgDetails.vue"; //查看简历/合同大图
import ImgUpload from "./components/ImgUpload.vue"; //上传
import ReasonWin from "../../firmCenter/firmAccount/components/ReasonWin.vue"; //驳回原因
import {
  viewEmployeeContractsAndResumes, //查询员工附件信息
  getCompanyEmployeeInfo, //次添加信用评价时回显员工基本信息以及附件
  editEmployeeAttachment, //编辑员工简历、合同 或者上传/更换员工信用评价申请
  deleteEmployeeAttachment, // 清空员工附件表
  cancelAppendAudit, // 取消追加审批
} from "../../../../assets/api/firm/HumanResources";
export default {
  data() {
    return {
      routeName: "",
      list: [
        {
          name: "在职",
          value: 1,
        },
        {
          name: "离职",
          value: 2,
        },
      ],
      typeValue: 1,
      formInline: {
        user: "",
        region: "",
      },
      dialogReason: false, //驳回原因
      BeforeTypeValue: 0, // 返回上一页时传递
      currentPage: 1, // 返回上一页时传递
      Information: {}, // 员工信息
      leaveOrNot: "", // 员工在职/离职数据来自接收上页面传过来的数据
      dialogIMGDetails: false, //查看上传的合同简历图片弹窗
      dialogUpload: false, // 上传劳动合同/简历
      Title: "", // 上传弹窗标题
      ClearNum: 0, // 1清空合同  2清空简历  3清空评价申请
      Attachment: {}, // 附件信息
      IMGdata: [], // 传给查看大图组件
    };
  },
  created() {
    this.routeName = this.$route.name;
    // 上一页进入详情页时的数据 保存如果返回时在传给上一页 让上一页恢复到跳转之前的数据
    if (
      this.$route.query.typeValue != "" &&
      this.$route.query.typeValue != undefined
    ) {
      this.BeforeTypeValue = this.$route.query.typeValue;
      this.currentPage = this.$route.query.currentPage;
      this.leaveOrNot = this.$route.query.leaveOrNot;
      this.viewEmployeeContractsAndResumes();
      this.getCompanyEmployeeInfo();
    }
  },
  components: {
    ImgDetails, //大图
    ImgUpload,
    ReasonWin, //驳回原因
  },
  computed: {
    companyName() {
      const c = this.$store.getters.getCompany;
      return (c && c.name) || "";
    },
    hasContractFiles() {
      const list = this.Attachment.contractList;
      return Array.isArray(list) && list.length > 0;
    },
    hasResumeFiles() {
      const list = this.Attachment.resumeList;
      return Array.isArray(list) && list.length > 0;
    },
    contractFileCount() {
      const list = this.Attachment.contractList;
      return Array.isArray(list) ? list.length : 0;
    },
    resumeFileCount() {
      const list = this.Attachment.resumeList;
      return Array.isArray(list) ? list.length : 0;
    },
  },
  methods: {
    // 取消追加
    handleAddition() {
      this.$confirmWithScroll("该操作将取消追加审批，是否继续？", "提示").then(() => {
        var data = {
          data: {
            employeeId: this.Information.employeeId,
          },
        };
        cancelAppendAudit(data).then((res) => {
          if (res.code == 0) {
            this.viewEmployeeContractsAndResumes();
            this.getCompanyEmployeeInfo();
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      }).catch(() => {});
    },
    // 清空按钮
    handelClear(num) {
      if (!this.$checkAction()) return;
      this.ClearNum = num;
      this.$confirmWithScroll("该操作将清空附件内容，是否继续？", "提示").then(() => {
        var data = {
          data: {
            employeeId: this.Information.employeeId,
            attaType: this.ClearNum,
          },
        };
        deleteEmployeeAttachment(data).then((res) => {
          if (res.code == 0) {
            this.viewEmployeeContractsAndResumes();
            this.getCompanyEmployeeInfo();
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      }).catch(() => {});
    },
    // 关闭查看简历/合同大图弹窗
    handleCancel() {
      this.dialogIMGDetails = false;
    },
    // 打开合同/简历查看图片
    handelImgDetails(num) {
      // if (!this.$checkAction()) return
      if (num == 1) {
        if (!this.hasContractFiles) {
          this.$tool.PromptBox("error", "暂无劳动合同，无法查看");
          return;
        }
        this.IMGdata = this.Attachment.contractList;
      } else {
        if (!this.hasResumeFiles) {
          this.$tool.PromptBox("error", "暂无简历，无法查看");
          return;
        }
        this.IMGdata = this.Attachment.resumeList;
      }
      this.dialogIMGDetails = true;
    },
    // ------------------ 次添加信用评价时回显员工基本信息以及附件
    async getCompanyEmployeeInfo() {
      var data = {
        data: {
          companyId: this.$route.query.companyId,
          id: this.$route.query.employeeId,
        },
      };
      // 调用 接口
      const res = await getCompanyEmployeeInfo(data);
      this.Information = res.data;
    },

    // ------------------ 查询员工附件信息
    async viewEmployeeContractsAndResumes() {
      var data = {
        data: {
          companyId: this.$route.query.companyId,
          employeeId: this.$route.query.employeeId,
          leaveOrNot: this.$route.query.leaveOrNot,
        },
      };
      // 调用 接口
      const res = await viewEmployeeContractsAndResumes(data);
      this.Attachment = res.data;
    },
    // 返回文件管理首页
    handelReturn() {
      this.$router.push({
        path: "/Firm/talentFile",
        query: {
          typeValue: this.BeforeTypeValue,
          currentPage: this.currentPage,
        },
      });
    },
    goEdit(num) {
      console.log(num, "num");
      if (num == 0 || num == null) {
        if (!this.$checkAction()) return;
        // 未评价
        this.$router.push({
          path: "/Firm/talentFile/editEvaluate", //评价页面
          // path:'/Firm/talentFile/AddEditEvaluate', // 追加页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      } else if (num == 1) {
        // 审核中
      } else if (num == 2) {
        if (!this.$checkAction()) return;
        // 未通过
        this.$router.push({
          path: "/Firm/talentFile/editEvaluate", //评价页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      } else if (num == 3) {
        if (!this.$checkAction()) return;
        // 已通过
        this.$router.push({
          // path: "/Firm/talentFile/editEvaluate", //评价页面
          path: "/Firm/talentFile/AddEditEvaluate", // 追加页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      } else if (num == 4) {
        if (!this.$checkAction()) return;
        // 审核中（追加）
        this.handleAddition();
      } else if (num == 5) {
        if (!this.$checkAction()) return;
        // 未通过（追加）
        this.$router.push({
          // path: "/Firm/talentFile/editEvaluate", //评价页面
          path: "/Firm/talentFile/AddEditEvaluate", // 追加页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      } else if (num == 6) {
        // 已评价
        // 已通过
        this.$router.push({
          path: "/Firm/talentFile/ViewEditEvaluate", // 查看页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      } else if (num == 7) {
        if (!this.$checkAction()) return;
        // 未通过（追加）
        this.$router.push({
          // path: "/Firm/talentFile/editEvaluate", //评价页面
          path: "/Firm/talentFile/AddEditEvaluate", // 追加页面
          query: {
            companyId: this.Information.companyId, // 企业id
            employeeId: this.Information.employeeId, //员工id
          },
        });
      }
    },
    // 编辑/上传劳动合同
    onVisible() {
      if (!this.$checkAction()) return;
      this.Title = "劳动合同";
      this.dialogUpload = true;
    },
    // 编辑/上传简历
    onVisibleResume() {
      if (!this.$checkAction()) return;
      this.Title = "简历";
      this.dialogUpload = true;
    },
    // 上传确认
    handleUpload(val, val1) {
      console.log(val, val1);
      // val 新增的图片id集合  val1老图片被删除的ID集合
      var data = {
        data: {
          employeeId: this.Information.employeeId, //员工id
          attaType: this.Title == "劳动合同" ? 1 : this.Title == "简历" ? 2 : 0, //操作的附件类型
          addDocIdList: val, //添加的id集合
          deleteDocIdList: val1, //删除的id集合
        },
      };
      if (val != 0 || val1 != 0) {
        editEmployeeAttachment(data).then((res) => {
          if (res.code == 0) {
            this.viewEmployeeContractsAndResumes();
            this.getCompanyEmployeeInfo();
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      }

      this.dialogUpload = false;
    },
    // 上传取消
    handleCloseUpload() {
      this.dialogUpload = false;
    }
  },
};
</script>

<style lang="less" scoped>
//驳回原因
.Rejection {
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
  line-height: 16px;
  color: #409eff ;
  text-decoration: underline;
}
/deep/ .el-input__inner {
  border-color: #409eff ;
  line-height: 1px !important;
}

.box {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px;
  box-sizing: border-box;

  .information {
    width: 100%;
    height: 100px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    font-size: 12px;

    .left {
      width: 50%;
      display: flex;
      align-items: center;

      .left-img {
        width: 60px;
        margin-right: 20px;

        img {
          width: 100%;
        }
      }

      .left-text {
        font-size: 12px;
        color: #333333;
        font-weight: 400;

        span {
          margin-right: 20px;
        }
      }
    }

    .right {
      width: 50%;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
    }
  }
  .flex-box {
    justify-content: flex-start;
  }
  .box-item:nth-child(3) {
    margin-right: 0px;
  }
  .box-item {
    margin-right: 40px;
    width: 350px;
    height: 450px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;

    .top-right {
      display: flex;
      float: right;
      // border: 1px solid gold;
      .button-box {
        // min-width: 60px;
        padding: 0px 10px 0px 10px;
        height: 25px;
        background: #eeeeee;
        border-radius: 5px;
        font-size: 12px;
        line-height: 25px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        box-sizing: border-box;
        text-align: center;
      }
    }
  }

  .box-item:hover {
    outline: 1px solid #409eff ;
    box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
  }

  .box-item--no-file {
    cursor: default;
    &:hover {
      outline: none;
      box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    }
    .top-right .button-box {
      cursor: pointer;
    }
  }

  .active {
    box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
    border: 1px solid #409eff ;
  }

  .el-upload__text {
    font-size: 12px;
    margin-top: 12px;
    color: #999;
  }
}

.upload-img {
  position: relative;
  cursor: pointer;
  margin-top: 15px;
}
.sc-img {
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
.upload-img:hover .sc-img {
  display: block;
}

/deep/.el-upload .el-upload-dragger {
  width: 600px;
  border: 1px dashed #409eff ;
  height: 70px;
}
</style>
